module.exports = __webpack_public_path__ + "files/e29c71b88eccfe22ee419deaa37a2178.png";